import { HashRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Privacy from "@/pages/Privacy";

export default function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/datenschutz" element={<Privacy />} />
      </Routes>
    </HashRouter>
  );
}
